export const IOC_TYPES_MAP = {
  "ip-address": "IP",
  domain: "Domain",
  url: "URL",
  "file-hash-sha1": "Hash",
  "file-hash-sha256": "Hash",
  "file-hash-md5": "Hash",
  other: "Other",
  "user-agent": "User Agent",
  filename: "File Name",
  email: "E-Mail",
  mutex: "Mutex",
  "mitre-attack": "MITRE Attack"
};

export const SEARCHABLE_IOC_TYPES = [
  "ip",
  "domain",
  "url",
  "hash",
  "file name",
  "e-mail",
  "mutex"
];

export const SEARCH_KEYWORD_MAP: Record<string, string> = {
  hash: "hashes",
  url: "uri",
  domain: "domain",
  ip: "ip",
  "file name": "filename",
  "e-mail": "email",
  mutex: "mutex"
};
